import { render, staticRenderFns } from "./flickity.vue?vue&type=template&id=1392b54e"
import script from "./flickity.vue?vue&type=script&lang=js"
export * from "./flickity.vue?vue&type=script&lang=js"
import style0 from "./flickity.vue?vue&type=style&index=0&id=1392b54e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports